import { AxiosInstance } from 'axios';

import { AutocompleteResponse } from '../types';

export const createAutocompleteHandler =
  (client: AxiosInstance) => (term: string) =>
    client.get<AutocompleteResponse>(
      `/autocomplete/${encodeURIComponent(term)}`
    );
